export const PUBLIC_PRIVATE_MODEL = {
  USER_LOGGED_IN: 'Clientes logueados (app logueados).',
  USER_NOT_LOGGED_IN:
    'Clientes no logueados (Web pública y app sin loguearse).',
};
